import styled from 'styled-components';

export const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #efe1cc;

  ${Styles.desktop`
    flex-direction: row;
    padding: 0;
    align-items: stretch;
    margin-top: 190px;
  `}
`;
